module.exports = __webpack_public_path__ + "img/ie.27ddec87.svg";